import { AfterViewInit, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef
} from '@angular/material/dialog';
import { MatButton } from "@angular/material/button";

@Component({
  selector: 'confirm-dialog',
  providers: [],
  styleUrls: ['./confirm-dialog.scss'],
  standalone: true,
  imports: [
    MatDialogContent,
    TranslateModule,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './confirm-dialog.html'
})
export class ConfirmDialogComponent implements AfterViewInit {
    public color = '';
    public confirmText = '';
    public confirmActionText = '';
    constructor(
        public dialog: MatDialogRef<ConfirmDialogComponent>,
        private _translater: TranslateService,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        if (_data && _data.color) {
            this.color = _data.color;
        } else {
            this.color = 'warn';
        }

        if (_data && _data.confirmText) {
            this.confirmText = _data.confirmText;
        } else {
            this.confirmText = 'AreYouSureDeleteWarning';
        }

        if (_data && _data.confirmActionText) {
            this.confirmActionText = _data.confirmActionText;
        } else {
            this.confirmActionText = 'Delete';
        }
    }

    public ngAfterViewInit() { }

    public onConfirmClicked(): void {
        this.confirm(true);
    }

    private confirm(confirmed: boolean): void {
        this.dialog.close(confirmed);
    }
}
